import { styled } from "@mui/material";

import { IconProps } from "../../ProgressBarView/types";

export const Path = styled("path")(({ color }: IconProps) => {
  return {
    fill: color,
  };
});
